import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import { FaLongArrowAltLeft } from "react-icons/fa";
import { IoSettingsOutline } from "react-icons/io5";
import { useEffect, useState } from "react";

export default function Settings() {

    const [theme, setTheme] = useState("dark");

    useEffect(() => {
        const savedTheme = localStorage.getItem("theme");
        if (savedTheme) setTheme(savedTheme);
    }, []);

    const changeTheme = (mode) => {
        setTheme(mode);
        localStorage.setItem("theme", mode);
    };

    const pageBg = theme == "dark" ? "dashboard-bg" : "bg-light text-dark";
    const cardBg = theme == "dark" ? "backgroundd-bg text-light" : "bg-light shadow text-dark";

    return (
        <>

            <title>Travel App Settings – Customize Preferences & Theme | TravelToolkit</title>
            <meta name="description" content="Manage your preferences with TravelToolkit settings. Switch themes, customize your experience, and control app features for a smoother travel journey." />
            <meta name="keywords" content="app settings page, customize app theme, travel app preferences, user settings dashboard, dark mode light mode settings, app customization options" />

            <meta property="og:title" content="Travel App Settings – Customize Preferences & Theme | TravelToolkit" />
            <meta property="og:site_name" content="traveltoolkit" />
            <meta property="og:url" content="https://traveltoolkit.online/Emergency" />
            <meta property="og:description" content="Manage your preferences with TravelToolkit settings. Switch themes, customize your experience, and control app features for a smoother travel journey." />
            <meta property="og:image" content="earth.gif"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="@traveltoolkit" />
            <meta name="twitter:description" content="Manage your preferences with TravelToolkit settings. Switch themes, customize your experience, and control app features for a smoother travel journey." />
            <meta name="twitter:app:country" content="India" />

            <div className={`container-fluid p-0 ${theme}-theme`}>
                <div className="row g-0">
                    <Sidebar />
                    <div className={`col-md-9 col-lg-10 min-vh-100 p-3 offset-0 offset-lg-2 offset-md-2 ${pageBg}`}>
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="d-flex align-items-center gap-2">
                                <Link to="/Dashboard">
                                    <button className={theme === "dark" ? "btn btn-dark text-light" : "btn btn-gradientss text-light"}>
                                        <FaLongArrowAltLeft />
                                    </button>
                                </Link>
                                <h1 className={theme === "dark" ? "text-white mb-0 h4" : "text-dark mb-0 h4"}>
                                    Settings
                                </h1>
                            </div>
                            <div className="d-flex gap-2">
                                <Link to="/Settings">
                                    <button className="btn btn-gradientss text-light" >
                                        <IoSettingsOutline />
                                    </button>
                                </Link>
                            </div>
                        </div>
                        <div className={`card border-0 p-4 mb-4 ${cardBg}`}>
                            <h6 className=" mb-3">Appearance</h6>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <button
                                        className={`btn w-100 ${theme === "dark"
                                            ? "btn btn-gradientss text-light"
                                            : "btn-outline-secondary"
                                            }`}
                                        onClick={() => changeTheme("dark")}
                                    >
                                        Dark
                                    </button>
                                </div>
                                <div className="col-md-6">
                                    <button
                                        className={`btn w-100 ${theme === "light"
                                            ? "btn btn-gradientss text-light"
                                            : "btn-outline-secondary"
                                            }`}
                                        onClick={() => changeTheme("light")}>
                                        Light
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}